import React from "react";
import styled from "styled-components";
import { colors } from "../theme/colors";

const PreviewHeader = ({
  children,
  className,
  centered = true,
  ...props
}) => {
  return (
    <StyledPreviewHeader
      className={className}
      centered={centered}
      {...props}
    >
      {children}
    </StyledPreviewHeader>
  );
};

const StyledPreviewHeader = styled.div`
  color: rgb(0, 91, 148);
  background-color: rgb(243, 248, 252);
  display: block;
  padding: 12px 16px;
  margin: 8px 0;
  border-radius: 8px;
  font-weight: 500;
  border: 1px solid rgba(0, 91, 148, 0.1);
  transition: all 0.2s ease;

  ${({ centered }) => centered && `
    text-align: center;
  `}

  &:hover {
    background-color: rgb(238, 246, 252);
    border-color: rgba(0, 91, 148, 0.2);
  }
`;

export default PreviewHeader;
